function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.donationModule = document.querySelector('#donation-module');
    this.donationPopup = document.querySelector('donation-pop-up');
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    this.skipDonation = false;

    if (this.querySelector('[name="attributes[accept_policy]"]')) {
      this.acceptPolicy = this.querySelector('[name="attributes[accept_policy]"]').checked;
    }

    this.debouncedOnChange = debounce((event) => {
      if (event.target != document.getElementById('Cart-note') && !event.target.closest('donation-module') ) {
        this.onChange(event);
      }
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    // Submit form check
    this.form.addEventListener('submit', (event) => {
      this.submitForm(event);
    });

    // fake submit form button
    this.submitFormButtonHandler();
  }

  onChange(event) {
    if (event.target.name == "attributes[accept_policy]" ) {
      document.querySelector('[name="attributes[accept_policy]"]').classList.remove('error');
      document.getElementById('cart-errors').textContent = '';
      this.acceptPolicy = document.querySelector('[name="attributes[accept_policy]"]').checked;
      return false;
    }
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  // Check if the policy checkbox is checked and if the donation is set
  submitForm(event) {
    // Policy check
    let policyCheckbox = document.querySelector('[name="attributes[accept_policy]"]');
    if(policyCheckbox && !policyCheckbox.checked) {
      policyCheckbox.classList.add('error');
      document.getElementById('cart-errors').textContent = window.cartStrings.policy;
      event.preventDefault();
      return false;
    }

    // Donation check, if no donation then open the donation popup
    if (this.donationModule && this.donationPopup && !this.skipDonation) {
      // If the donation module is updating, wait for it to finish
      if (this.donationModule.isUpdating) {
        event.preventDefault();
        setTimeout(() => {
          // Submit the from to go to the checkout after a delay
          document.querySelector('[data-submit-cart-button]').dispatchEvent(new MouseEvent('click', {
            bubbles: false,
            cancelable: false,
          }));
        }, 250);
        return false;
      }
      if (!this.donationModule.roundUp && this.donationModule.freeAmount == 0) {
        this.donationPopup.toggle(true);
        event.preventDefault();
        return false;
      }
    }
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-cart-item-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-cart-footer-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      }
    ];
    if (document.getElementById('donation-module')) {
      sections.push({
        id: 'donation-module',
        section: document.getElementById('donation-module').dataset.id,
        selector:'[data-donation-module-content]'
      });
    }
    if (document.getElementById('donation-pop-up')) {
      sections.push({
        id: 'donation-pop-up',
        section: document.getElementById('donation-pop-up').dataset.id,
        selector:'[data-pop-up-donation-module-content]'
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading();

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        document.getElementById('cart-errors').textContent = '';

        const parsedState = parseJson(state);

        let count_items = parsedState.items.filter(item => !item.properties._donation_price && !item.properties._donation_type?.includes('-cart'));
        this.classList.toggle('is-empty', count_items.length == 0);
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (section.id == 'donation-pop-up') {
            return;
          }
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        if (document.querySelector('[name="attributes[accept_policy]"]')) {
          document.querySelector('[name="attributes[accept_policy]"]').checked = this.acceptPolicy;
        }

        this.updateLiveRegions(line, parsedState.item_count);
        document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();

        if (this.donationModule && this.donationModule.roundUp) {
          // update donation round up product on cart change.
          document.querySelector('donation-module').updateDonation();
        } else {
          this.disableLoading();
          this.submitFormButtonHandler();
        }

      })
      .catch((error) => {
        document.querySelector('.loading-overlay')?.classList.add('hidden');
        document.querySelectorAll('.cart__totals-subtotal-value').forEach(element => {
          element.classList.remove('hidden');
        });
        document.querySelector('[data-fake-submit-button]')?.removeAttribute('disabled');
        if (document.getElementById('cart-errors').length > 0) {
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
        }
        this.disableLoading();
      });
  }

  // show error texts, should not be deleted.
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount && document.getElementById(`Line-item-error-${line}`)) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    document.getElementById('main-cart-items')?.classList.add('cart__items--disabled');
    document.querySelector('.loading-overlay')?.classList.remove('hidden');
    document.querySelectorAll('.cart__totals-subtotal-value').forEach(element => {
      element.classList.add('hidden');
    });
    document.querySelector('[data-fake-submit-button]')?.setAttribute('disabled', true);
    document.activeElement?.blur();
    this.lineItemStatusElement?.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items')?.classList.remove('cart__items--disabled');
  }

  submitFormButtonHandler() {
    if (!document.querySelector('[data-fake-submit-button]')) {
      return false;
    }

    let fakeButton = document.querySelector('[data-fake-submit-button]');
    fakeButton.addEventListener('click', (event) => {
      event.preventDefault();

      // Submit the from to go to the checkout
      document.querySelector('[data-submit-cart-button]').dispatchEvent(new MouseEvent('click', {
        bubbles: false,
        cancelable: false,
      }));

    });
  }

}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}
